import Flex from "@/components/atoms/Flex";
import IconButton from "@/components/atoms/IconButton";
import { CardDetailsHeaderProps } from "@/interfaces/Card";
import { useDestroyTeamMutation } from "@/services/teams";
import { faArrowLeft, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { ElementRef, FC, useRef } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ToastContentProps, toast } from "react-toastify";
import AreYouSurToContinueModal from "../../modals/AreYouSurToContinueModal";

const TeamHeader: FC<CardDetailsHeaderProps> = ({ id, isEdit }) => {
  const DeleteModalRef =
    useRef<ElementRef<typeof AreYouSurToContinueModal>>(null);
  const [deleteTeamAsync] = useDestroyTeamMutation();
  const navigation = useNavigate();

  const onDelete = async () => {
    toast.promise(deleteTeamAsync(id).unwrap(), {
      pending: "Suppression de l'équipe en cours ...",
      success: {
        render() {
          DeleteModalRef.current?.showOrHiddenModal();
          navigation("/teams");
          return (
            <p className="mb-0 text-center">L'équipe a bien été supprimée</p>
          );
        },
      },
      error: {
        render({ data }: ToastContentProps<FetchBaseQueryError>) {
          return "Une erreur est survenue";
        },
      },
    });
  };

  return (
    <Card className="mb-3">
      <AreYouSurToContinueModal
        ref={DeleteModalRef}
        onContinue={onDelete}
        title="Souhaitez-vous vraiment supprimé l'équipe qui a pour id : {{id}} ?"
      />
      <Card.Header className="d-flex flex-between-center">
        <IconButton
          onClick={() => navigation(-1)}
          variant="nolina-default"
          size="sm"
          icon={faArrowLeft}
        />
        <Flex>
          <div
            className="bg-300 mx-3 d-xl-none"
            style={{ width: "1px", height: "29px" }}
          ></div>
          {!isEdit && (
            <IconButton
              href={`/teams/${id}/edit`}
              variant="nolina-default"
              size="sm"
              icon={faEdit}
              transform="shrink-2"
              iconAlign="middle"
              className="me-2"
            >
              <span className="d-none d-xl-inline-block ms-1">Modifier</span>
            </IconButton>
          )}
          <IconButton
            onClick={() => DeleteModalRef.current?.showOrHiddenModal(id)}
            variant="nolina-default"
            size="sm"
            icon={faTrash}
            iconAlign="middle"
            className="d-none d-sm-block me-2"
          >
            <span className="d-none d-xl-inline-block ms-1">Supprimer</span>
          </IconButton>
        </Flex>
      </Card.Header>
    </Card>
  );
};

export default TeamHeader;
